import { render } from "./BrandImage.vue?vue&type=template&id=b9381712"
import script from "./BrandImage.vue?vue&type=script&lang=js"
export * from "./BrandImage.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__